import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

const DisclaimerSection = () => {
  return (
    <div className="bg-gradient-to-b from-gray-50 via-white to-gray-100">
      <Navbar />

      {/* ================= HERO ================= */}
      <section className="text-center py-20 px-6">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeUp}
          className="max-w-3xl mx-auto"
        >
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900">
            Transparency & Safety First
          </h1>
          <p className="mt-4 text-gray-600 text-lg">
            We believe in clear guidance, responsible installation, and helping
            you make informed solar decisions.
          </p>
        </motion.div>
      </section>

      {/* ================= DISCLAIMER CARD ================= */}
      <section className="px-6">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          className="max-w-4xl mx-auto bg-white/70 backdrop-blur-xl border border-gray-200 shadow-xl rounded-2xl p-8 md:p-10"
        >
          <h2 className="text-2xl font-bold mb-6 text-gray-900">Disclaimer</h2>

          <div className="space-y-5 text-gray-700 leading-relaxed">
            <p>
              This website and its calculators are provided for informational
              purposes only. While we aim to simplify solar decision-making,
              results shown are estimates and should not be considered final
              engineering specifications.
            </p>

            <p>
              Solar energy systems involve high-voltage components and must be
              installed by licensed professionals. Improper installation may
              result in damage, injury, or system failure.
            </p>

            <p>
              Solaris Surge Energy Solutions is not liable for misuse of
              information provided on this platform. Always consult a qualified
              expert before proceeding with installation.
            </p>
          </div>
        </motion.div>
      </section>

      {/* ================= FOUNDER SECTION ================= */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          {/* IMAGE */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="absolute inset-0 bg-green-500/20 blur-3xl rounded-full" />
            <img
              src="/Assets/Odedeyi.jpeg"
              alt="Founder"
              className="relative z-10 w-full max-w-sm mx-auto rounded-2xl shadow-2xl object-cover"
            />
          </motion.div>

          {/* TEXT */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            variants={fadeUp}
            className="text-center md:text-left"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Meet the Expert Behind It All
            </h2>

            <p className="text-gray-700 mb-4 leading-relaxed">
              At Solaris Surge, every solution is backed by real-world
              experience. With years of hands-on expertise in solar
              installations, battery systems, and energy optimization, our
              mission is to make solar energy simple, reliable, and accessible.
            </p>

            <p className="text-gray-600 leading-relaxed">
              From residential setups to commercial projects, every system is
              carefully designed to meet real energy needs — not just estimates.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ================= TRUST CTA ================= */}
      <section className="pb-20 px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="max-w-3xl mx-auto text-center bg-white shadow-lg rounded-2xl p-8"
        >
          <h3 className="text-2xl font-semibold text-gray-900">
            Need a Professional Assessment?
          </h3>
          <p className="text-gray-600 mt-3">
            Get accurate, expert-backed solar recommendations tailored to your
            specific needs.
          </p>

          <a
            href="/contactsection"
            className="inline-block mt-6 bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-full shadow-lg transition transform hover:scale-105"
          >
            Request Consultation
          </a>
        </motion.div>
      </section>

      {/* WhatsApp */}
      <a
        href="https://wa.me/+2348165213568?text=Hi!"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-green-500 p-3 rounded-full shadow-lg hover:bg-green-400 transition"
      >
        <img src="/Assets/chats.png" alt="WhatsApp" className="w-8 h-8" />
      </a>

      <Footer />
    </div>
  );
};

export default DisclaimerSection;
